<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label" v-if="cards && cards.length > 0 && !loading">
        <p class="text">{{ this.$store.getters.TRANSLATIONS["vouchers"] }}</p>
      </div>
      <p class="content_title" v-if="cards.length > 0 && !loading">
        {{ this.$store.getters.TRANSLATIONS["list_of_vouchers"] }}
      </p>
      <div v-if="cards && cards.length <= 0 && !loading">
        <!-- No vouchers -->
        <img :src="logoIcon" class="logo" />
        <div class="message_block">
          <p class="first_text">
            {{ this.$store.getters.TRANSLATIONS["you_have_no_vouchers"] }}
            <br />{{ this.$store.getters.TRANSLATIONS["right_now"] }}
          </p>
          <div class="separator"></div>
          <p class="second_text">
            {{ this.$store.getters.TRANSLATIONS["organizations_can_send"] }}
            <br />{{ this.$store.getters.TRANSLATIONS["pay_for_valet"] }}
          </p>
        </div>
      </div>
      <div
        class="car"
        v-for="item in cards"
        :key="item.id"
        v-on:click="next(item)"
      >
        <div class="model">
          <button class="button">
            <p>{{ item.code }}</p>
          </button>
        </div>
      </div>
    </div>
    <div class="footer" v-if="!loading">
      <button v-on:click="add()" class="button add-button">
        {{ this.$store.getters.TRANSLATIONS["add"] }}
      </button>
    </div>
    <v-dialog style="margin-top: 25%; text-align: center" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  created() {
    if (
      this.$route.query &&
      this.$route.query.token &&
      this.$route.query.code
    ) {
      this.$store.dispatch("SAVE_TOKEN", this.$route.query.token);
      this.$storage.set("parkendaToken", this.$route.query.token);
    }
    const timeout = setTimeout(() => {
      this.loading = true;
    }, 0);
    this.$http
      .get(`${process.env.SERVER_URL}/2600ED9F52C14E3D929B271668DE977E`, {
        headers: {
          "x-access-token": this.$storage.get("parkendaToken")
        }
      })
      .then((response) => {
        console.log("Get current user response:");
        console.log(response);
        if (response.data) {
          this.$store.dispatch("SAVE_USER", response.data);
          this.defaultCardId = response.data.defaultCardId;
        }
        return this.$http.get(
          `${process.env.SERVER_URL}/E6A0FB9DE7E74C44B90F93B9049CAF12`,
          {
            headers: {
              "x-access-token": this.$storage.get("parkendaToken")
            }
          }
        );
      })
      .then((response) => {
        console.log("Get user loyalty campaign vouchers response:");
        console.log(response);
        if (response.data) {
          this.cards = response.data;
          if (this.$route.query.code) {
            if (this.cards.find((c) => c.code === this.$route.query.code)) {
              this.next(
                this.cards.filter((c) => c.code === this.$route.query.code)[0]
              );
            } else {
              this.$modal.show("dialog", {
                text: this.$store.getters.TRANSLATIONS["no_valid_or_expired"],
                buttons: [
                  {
                    title: "OK",
                    handler: () => {
                      this.$router.push("/login");
                    }
                  }
                ]
              });
            }
          }
        } else {
          console.log(
            "Can't get loyalty loyalty campaign vouchers information"
          );
        }
      })
      .catch((error) => {
        let text = this.$store.getters.TRANSLATIONS["something_went_wrong"];
        this.$modal.show("dialog", {
          text,
          buttons: [
            {
              title: "OK",
              handler: () => {
                this.$storage.remove("parkendaToken");
                this.$router.push("/hello");
              }
            }
          ]
        });
      })
      .finally(() => {
        clearTimeout(timeout);
        this.loading = false;
      });
  },
  data() {
    return {
      loading: true,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      logoIcon: require("@/assets/new_design/Parkenda_VerticalLogo_FullColour.png"),
      cards: [],
      cardIcon: require("@/assets/cardIcon.png"),
      nextIcon: require("@/assets/nextArrowIos.jpg"),
      next: (item) => {
        let User = this.$store.getters.USER;
        User.selectedMarketingVoucher = item;
        this.$store.dispatch("SAVE_USER", User);
        this.$router.push("/marketCampagnsEdit");
      },
      back: () => {
        this.$router.go(-1);
      },
      add: () => {
        this.$router.push("/marketCampagnsAdd");
      }
    };
  }
};
</script>

<style scoped src="../../styles/main.css"></style>
<style scoped>
.button {
  width: 80%;
  background-color: #72aeff;
}
.add-button {
  background-color: #fbae31;
  width: 50%;
}
.message_block {
  border: 1px solid #fbae31;
  border-radius: 30px;
  padding: 15px 10px;
  width: 80vw;
  margin: 10vh auto 0;
}
.first_text {
  margin: 10px;
  color: #fbae31;
}
.second_text {
  margin: 10px;
  color: #fbae31;
}
.separator {
  height: 1px;
  width: 30vw;
  background-color: #fbae31;
  margin: 0 auto;
}
.logo {
  width: 25%;
}
</style>



// WEBPACK FOOTER //
// src/components/MarketingCampaignVouchers/List.vue